import React from 'react';
import { IconProps } from '.';

const SvgColoredFingerFour = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#FFD653'
        d='M17.5 14.46c-.31.05-.48-.14-.56-.41-.09-.46-.07-1.16.1-2.14l1.83-8.24c.15-.63-.2-1.24-1.02-1.44-.82-.2-1.44.2-1.59.83l-1.64 7.47c-.33 1.65-.94 1.35-.79-.52l.47-8.76C14.34.58 13.82.03 13.05 0c-.77-.03-1.32.43-1.36 1.11l-.45 8.97c-.1 1.81-.74 1.13-.88-.18L9.32 2.64c-.11-.68-.75-1.16-1.52-1.03-.77.12-1.23.76-1.13 1.44l1 6.63c.4 2.53-.12 3.23-.98.48L5.62 6.13c-.17-.65-.81-1.05-1.61-.82-.8.22-1.15.87-.97 1.52l1.04 3.79c.44 2.73.44 3.81.44 5.68 0 1.87.86 7.7 7.47 7.7 6.61 0 7.97-6.71 8.03-7.14'
      />
      <path
        fill='#EC8A3C'
        d='M12.72 20.11c-.18.31-.67.37-.67 0 0-1.85.68-3.54 1.82-4.52.07-.06.13-.11.2-.16h-1.69a2.01 2.01 0 0 1 0-4.02h5.35c.87 0 .98.66 1.24 1.5m.38 3.9c0-.21-.18-.95-.25-1.19l-.73-2.4a.688.688 0 0 0-.64-.47h-5.35a.67.67 0 0 0 0 1.34h3.68c.38 0 .71.19.88.51.17.33.15.74-.07 1.06-.21.3-.54.47-.92.44-.42 0-.83.18-1.21.51'
      />
      <path
        fill='#FFD653'
        d='M12.72 20.11c0-1.71.64-3.2 1.59-4.02.49-.42 1.06-.67 1.67-.67.48.05.57-.67.08-.67h-3.68a1.34 1.34 0 0 1 0-2.68h5.35c.57 0 1.11.4 1.28.95l.73 2.4c.07.22.32 1.25.28 1.47'
      />
    </svg>
  );
};

export default SvgColoredFingerFour;
